// import { useContext, useState, useEffect, useCallback } from "react";
// import { API_URL } from "../../Constants";
// import { AuthContext } from "../context/AuthContext";
// import { Select } from "antd";
// import axios from "axios";
// import PhoneInput from 'react-phone-number-input';
// import 'react-phone-number-input/style.css';

// export default function ReminderForm({
//   leadId,
//   initialData = null,
//   onSubmit,
//   onClose,
//   setOpenForm = null
// }) {
//   const { user } = useContext(AuthContext);
//   const [users, setUsers] = useState([]);
//   const [customFrequency, setCustomFrequency] = useState("");
//   const [emailTemplates, setEmailTemplates] = useState([]);
//   const [smsTemplates, setSmsTemplates] = useState([]);
//   const [selectedEmailTemplate, setSelectedEmailTemplate] = useState(null);
//   const [selectedSmsTemplate, setSelectedSmsTemplate] = useState(null);
//   const [emailTemplateVariables, setEmailTemplateVariables] = useState([]);
//   const [smsTemplateVariables, setSmsTemplateVariables] = useState([]);
//   const [emailVariableValues, setEmailVariableValues] = useState({});
//   const [smsVariableValues, setSmsVariableValues] = useState({});
//   const [phoneErrors, setPhoneErrors] = useState({}); // Track phone number validation errors

//   const [formData, setFormData] = useState({
//     leadId: "",
//     companyId: user?.accountType === "COMPANY" ? user.id : user?.companyId,
//     createdById: user?.id,
//     createdByName: user?.name,
//     assignedTo: [],
//     reminderType: "MONTHLY",
//     message: "",
//     date: "",
//     time: "",
//     status: "Pending",
//     emailAutomated: false,
//     email: [""],
//     emailTemplateId: null,
//     emailVariables: [],
//     messageAutomated: false,
//     mobileNo: [""],
//     smsMessageId: null,
//     variables: [],
//   });

//   // Validation functions
//   const validateEmail = (email) => {
//     const re = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
//     return re.test(String(email).toLowerCase());
//   };

//   const validatePhoneNumber = (phoneNumber) => {
//     if (!phoneNumber) return false;
    
//     // Remove all non-digit characters
//     const digitsOnly = phoneNumber.replace(/\D/g, '');
    
//     // Check if the number has country code + 10 digits (total 12 digits for IN)
//     // Or if it's a local number with exactly 10 digits
//     return digitsOnly.length === 10 || (digitsOnly.length === 12 && digitsOnly.startsWith('91'));
//   };

//   const getPhoneNumberDigits = (phoneNumber) => {
//     if (!phoneNumber) return '';
//     return phoneNumber.replace(/\D/g, '');
//   };

//   const handlePhoneChange = (index, value) => {
//     const digits = getPhoneNumberDigits(value);
//     let error = '';
    
//     if (value && digits.length > 0) {
//       if (digits.length > 10 && !digits.startsWith('91')) {
//         error = 'Country code must be +91 for Indian numbers';
//       } else if (digits.length > 12) {
//         error = 'Phone number too long';
//       } else if (digits.length < 10) {
//         error = 'Phone number too short';
//       } else if (!validatePhoneNumber(value)) {
//         error = 'Please enter a valid 10-digit phone number';
//       }
//     }
    
//     // Update errors state
//     setPhoneErrors(prev => ({
//       ...prev,
//       [index]: error
//     }));
    
//     // Update form data
//     const updated = [...formData.mobileNo];
//     updated[index] = value;
//     setFormData(prev => ({ ...prev, mobileNo: updated }));
//   };

//   useEffect(() => {
//     setFormData((prev) => ({ ...prev, leadId }));
//   }, [leadId]);

//   useEffect(() => {
//     if (initialData) {
//       const formattedAssignedTo = (initialData.assignedTo || []).map((u) => ({
//         id: u.id || u._id,
//         name: u.name || `${u.fname} ${u.lname}`,
//       }));

//       const formattedVariables = initialData.variables 
//         ? Array.isArray(initialData.variables) 
//           ? initialData.variables 
//           : Object.values(initialData.variables)
//         : [];

//       const formattedEmailVariables = initialData.emailVariables 
//         ? Array.isArray(initialData.emailVariables) 
//           ? initialData.emailVariables 
//           : Object.values(initialData.emailVariables)
//         : [];

//       setFormData({
//         ...formData,
//         assignedTo: formattedAssignedTo || [],
//         reminderType: initialData.reminderType || "MONTHLY",
//         message: initialData.message || "",
//         date: initialData.date || "",
//         time: initialData.time || "",
//         status: initialData.status || "Pending",
//         emailAutomated: initialData.emailAutomated || false,
//         email: initialData.email || [""],
//         emailTemplateId: initialData.emailTemplateId || null,
//         emailVariables: formattedEmailVariables,
//         messageAutomated: initialData.messageAutomated || false,
//         mobileNo: initialData.mobileNo || [""],
//         smsMessageId: initialData.smsMessageId || null,
//         variables: formattedVariables,
//       });

//       // Set selected templates from initialData
//       setSelectedEmailTemplate(initialData.emailTemplateId || null);
//       setSelectedSmsTemplate(initialData.smsMessageId || null);

//       // Initialize variable values if they exist
//       if (initialData.emailTemplateId) {
//         const selectedTemplate = emailTemplates.find(
//           t => t.emailTemplateId === initialData.emailTemplateId
//         );
//         if (selectedTemplate) {
//           const vars = extractVariables(selectedTemplate.body);
//           setEmailTemplateVariables(vars);
          
//           const initialValues = {};
//           vars.forEach((v, i) => {
//             initialValues[v] = formattedEmailVariables[i] || "";
//           });
//           setEmailVariableValues(initialValues);
//         }
//       }

//       if (initialData.smsMessageId) {
//         const selectedTemplate = smsTemplates.find(
//           t => t.mesaageId === initialData.smsMessageId
//         );
//         if (selectedTemplate) {
//           const vars = extractVariables(selectedTemplate.templateText);
//           setSmsTemplateVariables(vars);
          
//           const initialValues = {};
//           vars.forEach((v, i) => {
//             initialValues[v] = formattedVariables[i] || "";
//           });
//           setSmsVariableValues(initialValues);
//         }
//       }
//     }
//   }, [initialData, emailTemplates, smsTemplates]);

//   const fetchEmailTemplates = useCallback(async () => {
//     try {
//       const companyId = user?.accountType === "COMPANY" ? user?.id : user?.companyId;
//       const response = await axios.get(
//         `${API_URL}/api/emailTemplates/company/${companyId}`,
//         {
//           headers: {
//             Authorization: `Bearer ${localStorage.getItem("token")}`,
//           },
//         }
//       );
//       setEmailTemplates(response.data.emailTemplates || []);
//     } catch (error) {
//       console.error("Error fetching email templates:", error);
//     }
//   }, [user]);

//   const fetchSmsTemplates = useCallback(async () => {
//     try {
//       const companyId = user?.accountType === "COMPANY" ? user?.id : user?.companyId;
//       const response = await axios.get(
//         `${API_URL}/api/smsTemplates/company/${companyId}`,
//         {
//           headers: {
//             Authorization: `Bearer ${localStorage.getItem("token")}`,
//           },
//         }
//       );
//       setSmsTemplates(response.data.smsTemplates || []);
//     } catch (error) {
//       console.error("Error fetching SMS templates:", error);
//     }
//   }, [user]);

//   useEffect(() => {
//     if (user?.id) {
//       fetchEmailTemplates();
//     }
//   }, [user, fetchEmailTemplates]);

//   useEffect(() => {
//     if (user?.id) {
//       fetchSmsTemplates();
//     }
//   }, [user, fetchSmsTemplates]);

//   const extractVariables = (body) => {
//     if (!body) return [];
//     const regex = /\{\{(.*?)\}\}/g;
//     const matches = body.match(regex);
//     if (!matches) return [];
    
//     return [...new Set(matches)];
//   };

//   const handleEmailTemplateSelect = (templateId) => {
//     setSelectedEmailTemplate(templateId);
//     const selected = emailTemplates.find(t => t.emailTemplateId === templateId);
//     if (selected) {
//       const vars = extractVariables(selected.body);
//       setEmailTemplateVariables(vars);
      
//       const initialValues = {};
//       vars.forEach(v => {
//         initialValues[v] = emailVariableValues[v] || "";
//       });
//       setEmailVariableValues(initialValues);
      
//       setFormData(prev => ({
//         ...prev,
//         emailTemplateId: templateId,
//         emailVariables: vars.map(v => initialValues[v] || "")
//       }));
//     }
//   };

//   const handleSmsTemplateSelect = (templateId) => {
//     setSelectedSmsTemplate(templateId);
//     const selected = smsTemplates.find(t => t.mesaageId === templateId);
//     if (selected) {
//       const vars = extractVariables(selected.templateText);
//       setSmsTemplateVariables(vars);
      
//       const initialValues = {};
//       vars.forEach(v => {
//         initialValues[v] = smsVariableValues[v] || "";
//       });
//       setSmsVariableValues(initialValues);
      
//       setFormData(prev => ({
//         ...prev,
//         smsMessageId: templateId,
//         variables: vars.map(v => initialValues[v] || ""
//       )}));
//     }
//   };

//   const replaceVariables = (template, values) => {
//     let result = template;
//     Object.entries(values).forEach(([variable, value]) => {
//       result = result.replace(new RegExp(variable, 'g'), value);
//     });
//     return result;
//   };

//   const handleEmailVariableChange = (variable, value) => {
//     const updatedValues = {
//       ...emailVariableValues,
//       [variable]: value
//     };
//     setEmailVariableValues(updatedValues);
    
//     setFormData(prev => {
//       const variableIndex = emailTemplateVariables.indexOf(variable);
//       const newVariables = [...prev.emailVariables];
//       if (variableIndex >= 0) {
//         newVariables[variableIndex] = value;
//       }
//       return {
//         ...prev,
//         emailVariables: newVariables
//       };
//     });
//   };

//   const handleSmsVariableChange = (variable, value) => {
//     const updatedValues = {
//       ...smsVariableValues,
//       [variable]: value
//     };
//     setSmsVariableValues(updatedValues);
    
//     setFormData(prev => {
//       const variableIndex = smsTemplateVariables.indexOf(variable);
//       const newVariables = [...prev.variables];
//       if (variableIndex >= 0) {
//         newVariables[variableIndex] = value;
//       }
//       return {
//         ...prev,
//         variables: newVariables
//       };
//     });
//   };

//   const getEmailTemplatePreview = () => {
//     const selected = emailTemplates.find(t => t.emailTemplateId === selectedEmailTemplate);
//     if (!selected) return "";
    
//     return replaceVariables(selected.body, emailVariableValues);
//   };

//   const getSmsTemplatePreview = () => {
//     const selected = smsTemplates.find(t => t.mesaageId === selectedSmsTemplate);
//     if (!selected) return "";
    
//     return replaceVariables(selected.templateText, smsVariableValues);
//   };

//   useEffect(() => {
//     async function fetchUsers() {
//       if (!user?.id || !user?.accountType) return;
//       const url =
//         user.accountType === "COMPANY"
//           ? `${API_URL}/api/companyuser/getByUserId?userId=${user.id}&accountType=${user.accountType}`
//           : `${API_URL}/api/companyuser/getSameAndSubordinateUsers?userId=${user.id}&accountType=${user.accountType}`;

//       try {
//         const response = await fetch(url, {
//           method: "GET",
//           headers: {
//             authorization: `Bearer ${localStorage.getItem("token")}`,
//             "Content-Type": "application/json",
//           },
//         });

//         if (!response.ok) {
//           throw new Error(`HTTP error! Status: ${response.status}`);
//         }

//         const data = await response.json();
//         setUsers(data);
//       } catch (error) {
//         console.error("Error fetching users:", error);
//       }
//     }

//     fetchUsers();
//   }, [user]);

//   const handleChange = (e) => {
//     const { name, value, type, checked } = e.target;
//     setFormData((prev) => ({
//       ...prev,
//       [name]: type === "checkbox" ? checked : value,
//     }));
//   };

//   const handleEmailChange = (index, value) => {
//     const updated = [...formData.email];
//     updated[index] = value;
//     setFormData((prev) => ({ ...prev, email: updated }));
//   };

//   const addEmailField = () =>
//     setFormData((prev) => ({ ...prev, email: [...prev.email, ""] }));
//   const removeEmailField = (index) =>
//     setFormData((prev) => ({
//       ...prev,
//       email: prev.email.filter((_, i) => i !== index),
//     }));

//   const addMobileField = () => {
//     setFormData((prev) => ({
//       ...prev,
//       mobileNo: [...prev.mobileNo, ""],
//     }));
//     // Initialize error state for new field
//     setPhoneErrors(prev => ({
//       ...prev,
//       [formData.mobileNo.length]: ''
//     }));
//   };

//   const removeMobileField = (index) => {
//     setFormData((prev) => ({
//       ...prev,
//       mobileNo: prev.mobileNo.filter((_, i) => i !== index),
//     }));
//     // Remove error state for removed field
//     const newErrors = {...phoneErrors};
//     delete newErrors[index];
//     setPhoneErrors(newErrors);
//   };

//   const handleSubmit = (e) => {
//     e.preventDefault();

//     // Validate emails if email automation is enabled
//     if (formData.emailAutomated) {
//       for (const email of formData.email) {
//         if (!validateEmail(email)) {
//           alert(`Invalid email address: ${email}`);
//           return;
//         }
//       }
//     }

//     // Validate phone numbers if message automation is enabled
//     if (formData.messageAutomated) {
//       let hasPhoneErrors = false;
//       const newPhoneErrors = {};
      
//       formData.mobileNo.forEach((phone, index) => {
//         if (!validatePhoneNumber(phone)) {
//           newPhoneErrors[index] = 'Please enter a valid 10-digit phone number';
//           hasPhoneErrors = true;
//         } else {
//           newPhoneErrors[index] = '';
//         }
//       });
      
//       setPhoneErrors(newPhoneErrors);
      
//       if (hasPhoneErrors) {
//         alert('Please correct the phone number errors before submitting');
//         return;
//       }
//     }

//     let frequency = 1; // default

//     switch (formData.reminderType) {
//       case "DAILY":
//         frequency = 1;
//         break;
//       case "MONTHLY":
//         frequency = 30;
//         break;
//       case "YEARLY":
//         frequency = 360;
//         break;
//       case "CUSTOM":
//         frequency = parseInt(customFrequency, 10);
//         break;
//       default:
//         frequency = 1;
//     }

//     const updatedFormData = {
//       ...formData,
//       frequency,
//       emailTemplateId: formData.emailAutomated ? selectedEmailTemplate : null,
//       smsMessageId: formData.messageAutomated ? selectedSmsTemplate : null,
//       emailVariables: formData.emailAutomated ? formData.emailVariables : [],
//       variables: formData.messageAutomated ? formData.variables : []
//     };

//     if (onSubmit) {
//       onSubmit(updatedFormData);
//     } else {
//       createReminder(updatedFormData);
//     }

//     if (setOpenForm) {
//       setOpenForm(null);
//     }
//   };

//   const createReminder = async (data) => {
//     try {
//       const response = await axios.post(`${API_URL}/api/reminders`, data, {
//         headers: {
//           Authorization: `Bearer ${localStorage.getItem("token")}`,
//         },
//       });

//       if (response.data?.status === "Successful") {
//         // Dispatch event to refresh reminders table
//         window.dispatchEvent(new Event('reminderCreated'));
//       }
//     } catch (error) {
//       console.error("Error creating reminder:", error);
//     }
//   };

//   return (
//     <form onSubmit={handleSubmit} className="p-4 max-w-2xl mx-auto space-y-4">
//       {/* Reminder Type */}
//       <div>
//         <label className="block font-semibold mb-2">Reminder Type</label>
//         <div className="flex flex-wrap gap-4">
//           {["DAILY", "MONTHLY", "YEARLY", "CUSTOM"].map((type) => (
//             <label key={type} className="flex items-center gap-2">
//               <input
//                 type="radio"
//                 name="reminderType"
//                 value={type}
//                 checked={formData.reminderType === type}
//                 onChange={handleChange}
//               />
//               <span
//                 className={
//                   formData.reminderType === type
//                     ? "font-bold text-blue-600"
//                     : ""
//                 }
//               >
//                 {type.replace("_", " ")}
//               </span>
//             </label>
//           ))}
//         </div>
//         {formData.reminderType === "CUSTOM" && (
//           <div className="mt-2">
//             <label className="block mb-2">Custom Frequency (in days)</label>
//             <input
//               type="number"
//               min="1"
//               value={customFrequency}
//               onChange={(e) => setCustomFrequency(e.target.value)}
//               className="w-full p-2 border rounded dark:bg-gray-700"
//               placeholder="Enter number of days"
//               required
//             />
//           </div>
//         )}
//       </div>

//       {/* Date & Assigned To */}
//       <div className="grid grid-cols-1 sm:grid-cols-2 gap-4">
//         <div>
//           <label className="block mb-2">Reminder Date</label>
//           <input
//             type="date"
//             name="date"
//             className="w-full p-2 border rounded dark:bg-gray-700"
//             value={formData.date}
//             onChange={(e) => {
//               handleChange(e);
//               // Reset time if date is changed to today
//               if (e.target.value === new Date().toISOString().split('T')[0]) {
//                 const now = new Date();
//                 const currentHour = now.getHours().toString().padStart(2, '0');
//                 const currentMinute = now.getMinutes().toString().padStart(2, '0');
//                 const currentTime = `${currentHour}:${currentMinute}`;
                
//                 setFormData(prev => ({
//                   ...prev,
//                   time: currentTime
//                 }));
//               }
//             }}
//             min={new Date().toISOString().split("T")[0]}
//             required
//           />
//         </div>
//         <div>
//           <label className="block mb-2">Reminder Time</label>
//           <input
//             type="time"
//             name="time"
//             className="w-full p-2 border rounded dark:bg-gray-700"
//             value={formData.time}
//             onChange={handleChange}
//             min={
//               formData.date === new Date().toISOString().split('T')[0] 
//                 ? new Date().toTimeString().slice(0, 5) 
//                 : null
//             }
//             required
//           />
//         </div>
//       </div>

//       <div className="w-full">
//         <label className="block text-sm font-medium text-gray-700 mb-1 dark:text-white">
//           Assign To
//         </label>
//         <Select
//           mode="multiple"
//           labelInValue
//           value={formData.assignedTo.map((user) => ({
//             key: user.id,
//             label: user.name,
//           }))}
//           onChange={(values) => {
//             const updated = values.map((v) => ({
//               id: v.key,
//               name: v.label,
//             }));
//             setFormData((prev) => ({ ...prev, assignedTo: updated }));
//           }}
//           options={users.map((user) => ({
//             value: user.id,
//             label: `${user.fname} ${user.lname}`,
//           }))}
//           className="w-full p-2 dark:bg-gray-700"
//         />
//       </div>

//       {/* Message */}
//       <div>
//         <label className="block mb-2">Message</label>
//         <textarea
//           name="message"
//           className="w-full p-2 border rounded dark:bg-gray-700"
//           rows="3"
//           placeholder="Write your reminder message..."
//           value={formData.message}
//           onChange={handleChange}
//         ></textarea>
//       </div>

//       {/* Email Automation */}
//       <div>
//         <label className="flex items-center gap-2 mb-2">
//           <input
//             type="checkbox"
//             name="emailAutomated"
//             checked={formData.emailAutomated}
//             onChange={handleChange}
//           />
//           Enable Email Automation
//         </label>

//         {formData.emailAutomated && (
//           <>
//             {emailTemplates.length > 0 ? (
//               <div className="mb-4">
//                 <label className="block text-gray-700 mb-2 dark:text-white">
//                   Select Email Template:
//                 </label>
//                 <select
//                   className="border p-2 w-full rounded dark:bg-gray-700 dark:text-white"
//                   value={selectedEmailTemplate || ""}
//                   onChange={(e) => handleEmailTemplateSelect(e.target.value)}
//                 >
//                   <option value="">-- Select Template --</option>
//                   {emailTemplates.map((template) => (
//                     <option
//                       key={template.emailTemplateId}
//                       value={template.emailTemplateId}
//                     >
//                       {template.subject}
//                     </option>
//                   ))}
//                 </select>

//                 {selectedEmailTemplate && (
//                   <div className="mt-4">
//                     <h4 className="font-semibold mb-2">Email Template Preview:</h4>
//                     <div className="p-4 border rounded bg-gray-50 dark:bg-gray-800 mb-4 whitespace-pre-wrap">
//                       {getEmailTemplatePreview()}
//                     </div>

//                     {emailTemplateVariables.length > 0 && (
//                       <div className="mb-4">
//                         <h4 className="font-semibold mb-2">Email Variables:</h4>
//                         {emailTemplateVariables.map((variable, index) => (
//                           <div key={index} className="mb-2">
//                             <label className="block mb-1">{variable}</label>
//                             <input
//                               type="text"
//                               value={emailVariableValues[variable] || ""}
//                               onChange={(e) => handleEmailVariableChange(variable, e.target.value)}
//                               className="w-full p-2 border rounded dark:bg-gray-700"
//                               placeholder={`Enter value for ${variable}`}
//                             />
//                           </div>
//                         ))}
//                       </div>
//                     )}
//                   </div>
//                 )}
//               </div>
//             ) : (
//               <p className="mb-4 text-sm text-gray-500">
//                 No email templates found.{" "}
//                 <a
//                   href="/emailTemplates"
//                   className="text-blue-600 hover:underline ml-1"
//                   rel="noopener noreferrer"
//                 >
//                   Create templates here
//                 </a>
//               </p>
//             )}

//             {formData.email.map((email, index) => (
//               <div key={index} className="flex gap-2 mb-2">
//                 <div className="flex-grow">
//                   <input
//                     type="email"
//                     value={email}
//                     onChange={(e) => handleEmailChange(index, e.target.value)}
//                     className={`w-full p-2 border rounded dark:bg-gray-700 ${
//                       email && !validateEmail(email) ? 'border-red-500' : ''
//                     }`}
//                     placeholder="Enter email address"
//                   />
//                   {email && !validateEmail(email) && (
//                     <p className="text-red-500 text-xs mt-1">Invalid email format</p>
//                   )}
//                 </div>
//                 {index > 0 && (
//                   <button
//                     type="button"
//                     onClick={() => removeEmailField(index)}
//                     className="text-red-500"
//                   >
//                     Remove
//                   </button>
//                 )}
//               </div>
//             ))}

//             <button
//               type="button"
//               onClick={addEmailField}
//               className="text-blue-600 underline"
//             >
//               + Add another email
//             </button>
//           </>
//         )}
//       </div>

//       {/* Message Automation */}
//       <div>
//         <label className="flex items-center gap-2 mb-2">
//           <input
//             type="checkbox"
//             name="messageAutomated"
//             checked={formData.messageAutomated}
//             onChange={handleChange}
//           />
//           Enable Message Automation
//         </label>

//         {formData.messageAutomated && (
//           <>
//             {smsTemplates.length > 0 ? (
//               <div className="mb-4">
//                 <label className="block text-gray-700 mb-2 dark:text-white">
//                   Select SMS Template:
//                 </label>
//                 <select
//                   className="border p-2 w-full rounded dark:bg-gray-700 dark:text-white"
//                   value={selectedSmsTemplate || ""}
//                   onChange={(e) => handleSmsTemplateSelect(e.target.value)}
//                 >
//                   <option value="">-- Select Template --</option>
//                   {smsTemplates.map((template) => (
//                     <option
//                       key={template.mesaageId}
//                       value={template.mesaageId}
//                     >
//                       {template.templateType}
//                     </option>
//                   ))}
//                 </select>

//                 {selectedSmsTemplate && (
//                   <div className="mt-4">
//                     <h4 className="font-semibold mb-2">SMS Template Preview:</h4>
//                     <div className="p-4 border rounded bg-gray-50 dark:bg-gray-800 mb-4 whitespace-pre-wrap">
//                       {getSmsTemplatePreview()}
//                     </div>

//                     {smsTemplateVariables.length > 0 && (
//                       <div className="mb-4">
//                         <h4 className="font-semibold mb-2">Variables:</h4>
//                         {smsTemplateVariables.map((variable, index) => (
//                           <div key={index} className="mb-2">
//                             <label className="block mb-1">{variable}</label>
//                             <input
//                               type="text"
//                               value={smsVariableValues[variable] || ""}
//                               onChange={(e) => handleSmsVariableChange(variable, e.target.value)}
//                               className="w-full p-2 border rounded dark:bg-gray-700"
//                               placeholder={`Enter value for ${variable}`}
//                             />
//                           </div>
//                         ))}
//                       </div>
//                     )}
//                   </div>
//                 )}
//               </div>
//             ) : (
//               <p className="mb-4 text-sm text-gray-500">
//                 No SMS templates found.{" "}
//                 <a
//                   href="/smsTemplates"
//                   className="text-blue-600 hover:underline ml-1"
//                   rel="noopener noreferrer"
//                 >
//                   Create templates here
//                 </a>
//               </p>
//             )}

//             {formData.mobileNo.map((number, index) => (
//               <div key={index} className="mb-2">
//                 <label className="block text-sm font-medium text-gray-700 mb-1 dark:text-white">
//                   Mobile Number {index > 0 ? index + 1 : ''}
//                 </label>
//                 <div className="flex gap-2">
//                   <PhoneInput
//                     international
//                     defaultCountry="IN"
//                     value={number}
//                     onChange={(value) => handlePhoneChange(index, value)}
//                     className="w-full dark:bg-gray-700 dark:text-black"
//                     inputClassName={`w-full p-2 border rounded  ${
//                       phoneErrors[index] ? 'border-red-500' : ''
//                     }`}
//                     countrySelectProps={{
//                       className: "p-2 border rounded dark:bg-gray-700"
//                     }}
//                   />
//                   {index > 0 && (
//                     <button
//                       type="button"
//                       onClick={() => removeMobileField(index)}
//                       className="text-red-500 self-center"
//                     >
//                       Remove
//                     </button>
//                   )}
//                 </div>
//                 {phoneErrors[index] && (
//                   <p className="text-red-500 text-xs mt-1">
//                     {phoneErrors[index]}
//                   </p>
//                 )}
//               </div>
//             ))}

//             <button
//               type="button"
//               onClick={addMobileField}
//               className="text-blue-600 underline"
//             >
//               + Add another number
//             </button>
//           </>
//         )}
//       </div>

//       {/* Status */}
//       <div>
//         <label className="block font-semibold mb-2">Status</label>
//         <div className="flex flex-wrap gap-4">
//           {["Pending", "Completed"].map((type) => (
//             <label key={type} className="flex items-center gap-2">
//               <input
//                 type="radio"
//                 name="status"
//                 value={type}
//                 checked={formData.status === type}
//                 onChange={handleChange}
//               />
//               <span
//                 className={
//                   formData.status === type ? "font-bold text-blue-600" : ""
//                 }
//               >
//                 {type.replace("_", " ")}
//               </span>
//             </label>
//           ))}
//         </div>
//       </div>

//       {/* Submit */}
//       <div className="flex justify-end">
//         <button
//           type="submit"
//           className="px-4 py-2 bg-indigo-600 text-white rounded hover:bg-indigo-700"
//         >
//           {initialData ? "Update Reminder" : "Create Reminder"}
//         </button>
//       </div>
//     </form>
//   );
// }



// import { useContext, useState, useEffect, useCallback } from "react";
// import { API_URL } from "../../Constants";
// import { AuthContext } from "../context/AuthContext";
// import { Select } from "antd";
// import axios from "axios";
// import PhoneInput from 'react-phone-number-input';
// import 'react-phone-number-input/style.css';

// export default function ReminderForm({
//   leadId,
//   initialData = null,
//   onSubmit,
//   onClose,
//   setOpenForm = null
// }) {
//   const { user } = useContext(AuthContext);
//   const [users, setUsers] = useState([]);
//   const [customFrequency, setCustomFrequency] = useState("");
//   const [emailTemplates, setEmailTemplates] = useState([]);
//   const [smsTemplates, setSmsTemplates] = useState([]);
//   const [selectedEmailTemplate, setSelectedEmailTemplate] = useState(null);
//   const [selectedSmsTemplate, setSelectedSmsTemplate] = useState(null);
//   const [emailTemplateVariables, setEmailTemplateVariables] = useState([]);
//   const [smsTemplateVariables, setSmsTemplateVariables] = useState([]);
//   const [emailVariableValues, setEmailVariableValues] = useState({});
//   const [smsVariableValues, setSmsVariableValues] = useState({});
//   const [phoneErrors, setPhoneErrors] = useState({}); // Track phone number validation errors

//   const [formData, setFormData] = useState({
//     leadId: "",
//     companyId: user?.accountType === "COMPANY" ? user.id : user?.companyId,
//     createdById: user?.id,
//     createdByName: user?.name,
//     assignedTo: [],
//     reminderType: "MONTHLY",
//     message: "",
//     date: "",
//     time: "",
//     status: "Pending",
//     emailAutomated: false,
//     email: [""],
//     emailTemplateId: null,
//     emailVariables: [],
//     messageAutomated: false,
//     mobileNo: [""],
//     smsMessageId: null,
//     variables: [],
//   });

//   // Validation functions
//   const validateEmail = (email) => {
//     const re = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
//     return re.test(String(email).toLowerCase());
//   };

//   const validatePhoneNumber = (phoneNumber) => {
//     if (!phoneNumber) return false;
    
//     // Remove all non-digit characters
//     const digitsOnly = phoneNumber.replace(/\D/g, '');
    
//     // Check if the number has country code + 10 digits (total 12 digits for IN)
//     // Or if it's a local number with exactly 10 digits
//     return digitsOnly.length === 10 || (digitsOnly.length === 12 && digitsOnly.startsWith('91'));
//   };

//   const getPhoneNumberDigits = (phoneNumber) => {
//     if (!phoneNumber) return '';
//     return phoneNumber.replace(/\D/g, '');
//   };

//   const handlePhoneChange = (index, value) => {
//     const digits = getPhoneNumberDigits(value);
//     let error = '';
    
//     if (value && digits.length > 0) {
//       if (digits.length > 10 && !digits.startsWith('91')) {
//         error = 'Country code must be +91 for Indian numbers';
//       } else if (digits.length > 12) {
//         error = 'Phone number too long';
//       } else if (digits.length < 10) {
//         error = 'Phone number too short';
//       } else if (!validatePhoneNumber(value)) {
//         error = 'Please enter a valid 10-digit phone number';
//       }
//     }
    
//     // Update errors state
//     setPhoneErrors(prev => ({
//       ...prev,
//       [index]: error
//     }));
    
//     // Update form data
//     const updated = [...formData.mobileNo];
//     updated[index] = value;
//     setFormData(prev => ({ ...prev, mobileNo: updated }));
//   };

//   useEffect(() => {
//     setFormData((prev) => ({ ...prev, leadId }));
//   }, [leadId]);

//   useEffect(() => {
//     if (initialData) {
//       const formattedAssignedTo = (initialData.assignedTo || []).map((u) => ({
//         id: u.id || u._id,
//         name: u.name || `${u.fname} ${u.lname}`,
//       }));

//       const formattedVariables = initialData.variables 
//         ? Array.isArray(initialData.variables) 
//           ? initialData.variables 
//           : Object.values(initialData.variables)
//         : [];

//       const formattedEmailVariables = initialData.emailVariables 
//         ? Array.isArray(initialData.emailVariables) 
//           ? initialData.emailVariables 
//           : Object.values(initialData.emailVariables)
//         : [];

//       setFormData({
//         ...formData,
//         assignedTo: formattedAssignedTo || [],
//         reminderType: initialData.reminderType || "MONTHLY",
//         message: initialData.message || "",
//         date: initialData.date || "",
//         time: initialData.time || "",
//         status: initialData.status || "Pending",
//         emailAutomated: initialData.emailAutomated || false,
//         email: initialData.email || [""],
//         emailTemplateId: initialData.emailTemplateId || null,
//         emailVariables: formattedEmailVariables,
//         messageAutomated: initialData.messageAutomated || false,
//         mobileNo: initialData.mobileNo || [""],
//         smsMessageId: initialData.smsMessageId || null,
//         variables: formattedVariables,
//       });

//       // Set selected templates from initialData
//       setSelectedEmailTemplate(initialData.emailTemplateId || null);
//       setSelectedSmsTemplate(initialData.smsMessageId || null);

//       // Initialize variable values if they exist
//       if (initialData.emailTemplateId) {
//         const selectedTemplate = emailTemplates.find(
//           t => t.emailTemplateId === initialData.emailTemplateId
//         );
//         if (selectedTemplate) {
//           const vars = extractVariables(selectedTemplate.body);
//           setEmailTemplateVariables(vars);
          
//           const initialValues = {};
//           vars.forEach((v, i) => {
//             initialValues[v] = formattedEmailVariables[i] || "";
//           });
//           setEmailVariableValues(initialValues);
//         }
//       }

//       if (initialData.smsMessageId) {
//         const selectedTemplate = smsTemplates.find(
//           t => t.mesaageId === initialData.smsMessageId
//         );
//         if (selectedTemplate) {
//           const vars = extractVariables(selectedTemplate.templateText);
//           setSmsTemplateVariables(vars);
          
//           const initialValues = {};
//           vars.forEach((v, i) => {
//             initialValues[v] = formattedVariables[i] || "";
//           });
//           setSmsVariableValues(initialValues);
//         }
//       }
//     }
//   }, [initialData, emailTemplates, smsTemplates]);

//   const fetchEmailTemplates = useCallback(async () => {
//     try {
//       const companyId = user?.accountType === "COMPANY" ? user?.id : user?.companyId;
//       const response = await axios.get(
//         `${API_URL}/api/emailTemplates/company/${companyId}`,
//         {
//           headers: {
//             Authorization: `Bearer ${localStorage.getItem("token")}`,
//           },
//         }
//       );
//       setEmailTemplates(response.data.emailTemplates || []);
//     } catch (error) {
//       console.error("Error fetching email templates:", error);
//     }
//   }, [user]);

//   const fetchSmsTemplates = useCallback(async () => {
//     try {
//       const companyId = user?.accountType === "COMPANY" ? user?.id : user?.companyId;
//       const response = await axios.get(
//         `${API_URL}/api/smsTemplates/company/${companyId}`,
//         {
//           headers: {
//             Authorization: `Bearer ${localStorage.getItem("token")}`,
//           },
//         }
//       );
//       setSmsTemplates(response.data.smsTemplates || []);
//     } catch (error) {
//       console.error("Error fetching SMS templates:", error);
//     }
//   }, [user]);

//   useEffect(() => {
//     if (user?.id) {
//       fetchEmailTemplates();
//     }
//   }, [user, fetchEmailTemplates]);

//   useEffect(() => {
//     if (user?.id) {
//       fetchSmsTemplates();
//     }
//   }, [user, fetchSmsTemplates]);

//   const extractVariables = (body) => {
//     if (!body) return [];
//     const regex = /\{\{(.*?)\}\}/g;
//     const matches = body.match(regex);
//     if (!matches) return [];
    
//     return [...new Set(matches)];
//   };

//   const handleEmailTemplateSelect = (templateId) => {
//     setSelectedEmailTemplate(templateId);
//     const selected = emailTemplates.find(t => t.emailTemplateId === templateId);
//     if (selected) {
//       const vars = extractVariables(selected.body);
//       setEmailTemplateVariables(vars);
      
//       const initialValues = {};
//       vars.forEach(v => {
//         initialValues[v] = emailVariableValues[v] || "";
//       });
//       setEmailVariableValues(initialValues);
      
//       setFormData(prev => ({
//         ...prev,
//         emailTemplateId: templateId,
//         emailVariables: vars.map(v => initialValues[v] || "")
//       }));
//     }
//   };

//   const handleSmsTemplateSelect = (templateId) => {
//     setSelectedSmsTemplate(templateId);
//     const selected = smsTemplates.find(t => t.mesaageId === templateId);
//     if (selected) {
//       const vars = extractVariables(selected.templateText);
//       setSmsTemplateVariables(vars);
      
//       const initialValues = {};
//       vars.forEach(v => {
//         initialValues[v] = smsVariableValues[v] || "";
//       });
//       setSmsVariableValues(initialValues);
      
//       setFormData(prev => ({
//         ...prev,
//         smsMessageId: templateId,
//         variables: vars.map(v => initialValues[v] || ""
//       )}));
//     }
//   };

//   const replaceVariables = (template, values) => {
//     let result = template;
//     Object.entries(values).forEach(([variable, value]) => {
//       result = result.replace(new RegExp(variable, 'g'), value);
//     });
//     return result;
//   };

//   const handleEmailVariableChange = (variable, value) => {
//     const updatedValues = {
//       ...emailVariableValues,
//       [variable]: value
//     };
//     setEmailVariableValues(updatedValues);
    
//     setFormData(prev => {
//       const variableIndex = emailTemplateVariables.indexOf(variable);
//       const newVariables = [...prev.emailVariables];
//       if (variableIndex >= 0) {
//         newVariables[variableIndex] = value;
//       }
//       return {
//         ...prev,
//         emailVariables: newVariables
//       };
//     });
//   };

//   const handleSmsVariableChange = (variable, value) => {
//     const updatedValues = {
//       ...smsVariableValues,
//       [variable]: value
//     };
//     setSmsVariableValues(updatedValues);
    
//     setFormData(prev => {
//       const variableIndex = smsTemplateVariables.indexOf(variable);
//       const newVariables = [...prev.variables];
//       if (variableIndex >= 0) {
//         newVariables[variableIndex] = value;
//       }
//       return {
//         ...prev,
//         variables: newVariables
//       };
//     });
//   };

//   const getEmailTemplatePreview = () => {
//     const selected = emailTemplates.find(t => t.emailTemplateId === selectedEmailTemplate);
//     if (!selected) return "";
    
//     return replaceVariables(selected.body, emailVariableValues);
//   };

//   const getSmsTemplatePreview = () => {
//     const selected = smsTemplates.find(t => t.mesaageId === selectedSmsTemplate);
//     if (!selected) return "";
    
//     return replaceVariables(selected.templateText, smsVariableValues);
//   };

//   useEffect(() => {
//     async function fetchUsers() {
//       if (!user?.id || !user?.accountType) return;
//       const url =
//         user.accountType === "COMPANY"
//           ? `${API_URL}/api/companyuser/getByUserId?userId=${user.id}&accountType=${user.accountType}`
//           : `${API_URL}/api/companyuser/getSameAndSubordinateUsers?userId=${user.id}&accountType=${user.accountType}`;

//       try {
//         const response = await fetch(url, {
//           method: "GET",
//           headers: {
//             authorization: `Bearer ${localStorage.getItem("token")}`,
//             "Content-Type": "application/json",
//           },
//         });

//         if (!response.ok) {
//           throw new Error(`HTTP error! Status: ${response.status}`);
//         }

//         const data = await response.json();
//         setUsers(data);
//       } catch (error) {
//         console.error("Error fetching users:", error);
//       }
//     }

//     fetchUsers();
//   }, [user]);

//   const handleChange = (e) => {
//     const { name, value, type, checked } = e.target;
//     setFormData((prev) => ({
//       ...prev,
//       [name]: type === "checkbox" ? checked : value,
//     }));
//   };

//   const handleEmailChange = (index, value) => {
//     const updated = [...formData.email];
//     updated[index] = value;
//     setFormData((prev) => ({ ...prev, email: updated }));
//   };

//   const addEmailField = () =>
//     setFormData((prev) => ({ ...prev, email: [...prev.email, ""] }));
//   const removeEmailField = (index) =>
//     setFormData((prev) => ({
//       ...prev,
//       email: prev.email.filter((_, i) => i !== index),
//     }));

//   const addMobileField = () => {
//     setFormData((prev) => ({
//       ...prev,
//       mobileNo: [...prev.mobileNo, ""],
//     }));
//     // Initialize error state for new field
//     setPhoneErrors(prev => ({
//       ...prev,
//       [formData.mobileNo.length]: ''
//     }));
//   };

//   const removeMobileField = (index) => {
//     setFormData((prev) => ({
//       ...prev,
//       mobileNo: prev.mobileNo.filter((_, i) => i !== index),
//     }));
//     // Remove error state for removed field
//     const newErrors = {...phoneErrors};
//     delete newErrors[index];
//     setPhoneErrors(newErrors);
//   };

//   const handleSubmit = (e) => {
//     e.preventDefault();

//     // Validate emails if email automation is enabled
//     if (formData.emailAutomated) {
//       for (const email of formData.email) {
//         if (!validateEmail(email)) {
//           alert(`Invalid email address: ${email}`);
//           return;
//         }
//       }
//     }

//     // Validate phone numbers if message automation is enabled
//     if (formData.messageAutomated) {
//       let hasPhoneErrors = false;
//       const newPhoneErrors = {};
      
//       formData.mobileNo.forEach((phone, index) => {
//         if (!validatePhoneNumber(phone)) {
//           newPhoneErrors[index] = 'Please enter a valid 10-digit phone number';
//           hasPhoneErrors = true;
//         } else {
//           newPhoneErrors[index] = '';
//         }
//       });
      
//       setPhoneErrors(newPhoneErrors);
      
//       if (hasPhoneErrors) {
//         alert('Please correct the phone number errors before submitting');
//         return;
//       }
//     }

//     let frequency = 1; // default

//     switch (formData.reminderType) {
//       case "DAILY":
//         frequency = 1;
//         break;
//       case "MONTHLY":
//         frequency = 30;
//         break;
//       case "YEARLY":
//         frequency = 360;
//         break;
//       case "CUSTOM":
//         frequency = parseInt(customFrequency, 10);
//         break;
//       default:
//         frequency = 1;
//     }

//     const updatedFormData = {
//       ...formData,
//       frequency,
//       emailTemplateId: formData.emailAutomated ? selectedEmailTemplate : null,
//       smsMessageId: formData.messageAutomated ? selectedSmsTemplate : null,
//       emailVariables: formData.emailAutomated ? formData.emailVariables : [],
//       variables: formData.messageAutomated ? formData.variables : []
//     };

//     if (onSubmit) {
//       onSubmit(updatedFormData);
//     } else {
//       createReminder(updatedFormData);
//     }

//     if (setOpenForm) {
//       setOpenForm(null);
//     }
//   };

//   const createReminder = async (data) => {
//     try {
//       const response = await axios.post(`${API_URL}/api/reminders`, data, {
//         headers: {
//           Authorization: `Bearer ${localStorage.getItem("token")}`,
//         },
//       });

//       if (response.data?.status === "Successful") {
//         // Dispatch event to refresh reminders table
//         window.dispatchEvent(new Event('reminderCreated'));
//       }
//     } catch (error) {
//       console.error("Error creating reminder:", error);
//     }
//   };

//   return (
//     <>
//       <style>{`
//         @import url('https://fonts.googleapis.com/css2?family=Sora:wght@600;700&family=Inter:wght@400;500;600&display=swap');
//         .cfg-heading { font-family: 'Sora', sans-serif; color: #1F2937; }
//         .cfg-font { font-family: 'Inter', sans-serif; }
        
//         /* Custom AntD Select Styles to match Theme */
//         .custom-antd-select .ant-select-selector {
//           border-color: #E5E7EB !important;
//           border-radius: 0.375rem !important;
//           min-height: 42px !important;
//           align-items: center;
//         }
//         .custom-antd-select.ant-select-focused .ant-select-selector {
//           border-color: #673AB7 !important;
//           box-shadow: 0 0 0 2px #E9D5FF !important;
//         }
//         .dark .custom-antd-select .ant-select-selector {
//           background-color: #374151 !important;
//           border-color: #4B5563 !important;
//           color: white !important;
//         }
//         .dark .custom-antd-select.ant-select-focused .ant-select-selector {
//           box-shadow: 0 0 0 2px #8B5CF6 !important;
//         }
//       `}</style>

//       <form onSubmit={handleSubmit} className="p-5 w-full mx-auto bg-white rounded-xl cfg-font border border-[#E5E7EB] dark:border-gray-700 dark:bg-gray-800 space-y-5 shadow-sm">
        
//         {/* Reminder Type */}
//         <div>
//           <label className="block text-sm font-semibold text-[#374151] mb-2 dark:text-gray-200">Reminder Type</label>
//           <div className="flex flex-wrap gap-4">
//             {["DAILY", "MONTHLY", "YEARLY", "CUSTOM"].map((type) => (
//               <label key={type} className="flex items-center gap-2 cursor-pointer">
//                 <input
//                   type="radio"
//                   name="reminderType"
//                   value={type}
//                   checked={formData.reminderType === type}
//                   onChange={handleChange}
//                   className="accent-[#673AB7] w-4 h-4"
//                 />
//                 <span
//                   className={`text-sm ${
//                     formData.reminderType === type
//                       ? "font-bold text-[#673AB7] dark:text-[#E9D5FF]"
//                       : "text-[#374151] dark:text-gray-300 font-medium"
//                   }`}
//                 >
//                   {type.replace("_", " ")}
//                 </span>
//               </label>
//             ))}
//           </div>
//           {formData.reminderType === "CUSTOM" && (
//             <div className="mt-3">
//               <label className="block text-sm font-semibold text-[#374151] mb-1.5 dark:text-gray-200">Custom Frequency (in days)</label>
//               <input
//                 type="number"
//                 min="1"
//                 value={customFrequency}
//                 onChange={(e) => setCustomFrequency(e.target.value)}
//                 className="w-full p-2.5 border border-[#E5E7EB] rounded-md focus:outline-none focus:ring-2 focus:ring-[#E9D5FF] focus:border-[#673AB7] dark:bg-gray-700 dark:border-gray-600 dark:text-white"
//                 placeholder="Enter number of days"
//                 required
//               />
//             </div>
//           )}
//         </div>

//         {/* Date & Assigned To */}
//         <div className="grid grid-cols-1 sm:grid-cols-2 gap-4">
//           <div>
//             <label className="block text-sm font-semibold text-[#374151] mb-1.5 dark:text-gray-200">Reminder Date</label>
//             <input
//               type="date"
//               name="date"
//               className="w-full p-2.5 border border-[#E5E7EB] rounded-md focus:outline-none focus:ring-2 focus:ring-[#E9D5FF] focus:border-[#673AB7] dark:bg-gray-700 dark:border-gray-600 dark:text-white"
//               value={formData.date}
//               onChange={(e) => {
//                 handleChange(e);
//                 // Reset time if date is changed to today
//                 if (e.target.value === new Date().toISOString().split('T')[0]) {
//                   const now = new Date();
//                   const currentHour = now.getHours().toString().padStart(2, '0');
//                   const currentMinute = now.getMinutes().toString().padStart(2, '0');
//                   const currentTime = `${currentHour}:${currentMinute}`;
                  
//                   setFormData(prev => ({
//                     ...prev,
//                     time: currentTime
//                   }));
//                 }
//               }}
//               min={new Date().toISOString().split("T")[0]}
//               required
//             />
//           </div>
//           <div>
//             <label className="block text-sm font-semibold text-[#374151] mb-1.5 dark:text-gray-200">Reminder Time</label>
//             <input
//               type="time"
//               name="time"
//               className="w-full p-2.5 border border-[#E5E7EB] rounded-md focus:outline-none focus:ring-2 focus:ring-[#E9D5FF] focus:border-[#673AB7] dark:bg-gray-700 dark:border-gray-600 dark:text-white"
//               value={formData.time}
//               onChange={handleChange}
//               min={
//                 formData.date === new Date().toISOString().split('T')[0] 
//                   ? new Date().toTimeString().slice(0, 5) 
//                   : null
//               }
//               required
//             />
//           </div>
//         </div>

//         <div className="w-full">
//           <label className="block text-sm font-semibold text-[#374151] mb-1.5 dark:text-gray-200">
//             Assign To
//           </label>
//           <Select
//             mode="multiple"
//             labelInValue
//             value={formData.assignedTo.map((user) => ({
//               key: user.id,
//               label: user.name,
//             }))}
//             onChange={(values) => {
//               const updated = values.map((v) => ({
//                 id: v.key,
//                 name: v.label,
//               }));
//               setFormData((prev) => ({ ...prev, assignedTo: updated }));
//             }}
//             options={users.map((user) => ({
//               value: user.id,
//               label: `${user.fname} ${user.lname}`,
//             }))}
//             className="w-full custom-antd-select"
//           />
//         </div>

//         {/* Message */}
//         <div>
//           <label className="block text-sm font-semibold text-[#374151] mb-1.5 dark:text-gray-200">Message</label>
//           <textarea
//             name="message"
//             className="w-full p-2.5 border border-[#E5E7EB] rounded-md focus:outline-none focus:ring-2 focus:ring-[#E9D5FF] focus:border-[#673AB7] min-h-[100px] dark:bg-gray-700 dark:border-gray-600 dark:text-white"
//             rows="3"
//             placeholder="Write your reminder message..."
//             value={formData.message}
//             onChange={handleChange}
//           ></textarea>
//         </div>

//         {/* Email Automation */}
//         <div className="bg-[#FAF8FF] dark:bg-gray-700 p-4 border border-[#E5E7EB] dark:border-gray-600 rounded-lg">
//           <label className="flex items-center gap-2 mb-3 cursor-pointer text-[#374151] dark:text-gray-200 font-semibold text-sm">
//             <input
//               type="checkbox"
//               name="emailAutomated"
//               checked={formData.emailAutomated}
//               onChange={handleChange}
//               className="accent-[#673AB7] w-4 h-4 rounded"
//             />
//             Enable Email Automation
//           </label>

//           {formData.emailAutomated && (
//             <div className="mt-3">
//               {emailTemplates.length > 0 ? (
//                 <div className="mb-4">
//                   <label className="block text-sm font-semibold text-[#374151] mb-1.5 dark:text-gray-200">
//                     Select Email Template:
//                   </label>
//                   <select
//                     className="w-full p-2.5 border border-[#E5E7EB] rounded-md focus:outline-none focus:ring-2 focus:ring-[#E9D5FF] focus:border-[#673AB7] dark:bg-gray-800 dark:border-gray-600 dark:text-white"
//                     value={selectedEmailTemplate || ""}
//                     onChange={(e) => handleEmailTemplateSelect(e.target.value)}
//                   >
//                     <option value="">-- Select Template --</option>
//                     {emailTemplates.map((template) => (
//                       <option
//                         key={template.emailTemplateId}
//                         value={template.emailTemplateId}
//                       >
//                         {template.subject}
//                       </option>
//                     ))}
//                   </select>

//                   {selectedEmailTemplate && (
//                     <div className="mt-4">
//                       <h4 className="text-sm font-semibold text-[#374151] mb-2 dark:text-gray-200">Email Template Preview:</h4>
//                       <div className="p-4 border border-[#E5E7EB] rounded-md bg-white dark:bg-gray-800 dark:border-gray-600 mb-4 whitespace-pre-wrap text-sm text-[#374151] dark:text-gray-300">
//                         {getEmailTemplatePreview()}
//                       </div>

//                       {emailTemplateVariables.length > 0 && (
//                         <div className="mb-4">
//                           <h4 className="text-sm font-semibold text-[#374151] mb-2 dark:text-gray-200">Email Variables:</h4>
//                           <div className="space-y-3">
//                             {emailTemplateVariables.map((variable, index) => (
//                               <div key={index}>
//                                 <label className="block text-xs font-medium text-[#6B7280] dark:text-gray-400 mb-1">{variable}</label>
//                                 <input
//                                   type="text"
//                                   value={emailVariableValues[variable] || ""}
//                                   onChange={(e) => handleEmailVariableChange(variable, e.target.value)}
//                                   className="w-full p-2 border border-[#E5E7EB] rounded-md focus:outline-none focus:ring-2 focus:ring-[#E9D5FF] focus:border-[#673AB7] dark:bg-gray-800 dark:border-gray-600 dark:text-white text-sm"
//                                   placeholder={`Enter value for ${variable}`}
//                                 />
//                               </div>
//                             ))}
//                           </div>
//                         </div>
//                       )}
//                     </div>
//                   )}
//                 </div>
//               ) : (
//                 <p className="mb-4 text-sm text-[#6B7280] dark:text-gray-400">
//                   No email templates found.{" "}
//                   <a
//                     href="/emailTemplates"
//                     className="text-[#673AB7] hover:text-[#5E35A6] hover:underline ml-1 font-semibold dark:text-[#E9D5FF]"
//                     rel="noopener noreferrer"
//                   >
//                     Create templates here
//                   </a>
//                 </p>
//               )}

//               {formData.email.map((email, index) => (
//                 <div key={index} className="flex gap-2 mb-3">
//                   <div className="flex-grow">
//                     <input
//                       type="email"
//                       value={email}
//                       onChange={(e) => handleEmailChange(index, e.target.value)}
//                       className={`w-full p-2.5 border rounded-md focus:outline-none focus:ring-2 focus:ring-[#E9D5FF] focus:border-[#673AB7] dark:bg-gray-800 dark:text-white ${
//                         email && !validateEmail(email) ? 'border-[#EF4444]' : 'border-[#E5E7EB] dark:border-gray-600'
//                       }`}
//                       placeholder="Enter email address"
//                     />
//                     {email && !validateEmail(email) && (
//                       <p className="text-[#EF4444] text-xs mt-1 font-medium">Invalid email format</p>
//                     )}
//                   </div>
//                   {index > 0 && (
//                     <button
//                       type="button"
//                       onClick={() => removeEmailField(index)}
//                       className="text-[#EF4444] hover:text-[#B91C1C] font-semibold text-sm px-2"
//                     >
//                       Remove
//                     </button>
//                   )}
//                 </div>
//               ))}

//               <button
//                 type="button"
//                 onClick={addEmailField}
//                 className="text-[#673AB7] hover:text-[#5E35A6] font-semibold text-sm transition dark:text-[#E9D5FF]"
//               >
//                 + Add another email
//               </button>
//             </div>
//           )}
//         </div>

//         {/* Message Automation */}
//         <div className="bg-[#FAF8FF] dark:bg-gray-700 p-4 border border-[#E5E7EB] dark:border-gray-600 rounded-lg">
//           <label className="flex items-center gap-2 mb-3 cursor-pointer text-[#374151] dark:text-gray-200 font-semibold text-sm">
//             <input
//               type="checkbox"
//               name="messageAutomated"
//               checked={formData.messageAutomated}
//               onChange={handleChange}
//               className="accent-[#673AB7] w-4 h-4 rounded"
//             />
//             Enable Message Automation
//           </label>

//           {formData.messageAutomated && (
//             <div className="mt-3">
//               {smsTemplates.length > 0 ? (
//                 <div className="mb-4">
//                   <label className="block text-sm font-semibold text-[#374151] mb-1.5 dark:text-gray-200">
//                     Select SMS Template:
//                   </label>
//                   <select
//                     className="w-full p-2.5 border border-[#E5E7EB] rounded-md focus:outline-none focus:ring-2 focus:ring-[#E9D5FF] focus:border-[#673AB7] dark:bg-gray-800 dark:border-gray-600 dark:text-white"
//                     value={selectedSmsTemplate || ""}
//                     onChange={(e) => handleSmsTemplateSelect(e.target.value)}
//                   >
//                     <option value="">-- Select Template --</option>
//                     {smsTemplates.map((template) => (
//                       <option
//                         key={template.mesaageId}
//                         value={template.mesaageId}
//                       >
//                         {template.templateType}
//                       </option>
//                     ))}
//                   </select>

//                   {selectedSmsTemplate && (
//                     <div className="mt-4">
//                       <h4 className="text-sm font-semibold text-[#374151] mb-2 dark:text-gray-200">SMS Template Preview:</h4>
//                       <div className="p-4 border border-[#E5E7EB] rounded-md bg-white dark:bg-gray-800 dark:border-gray-600 mb-4 whitespace-pre-wrap text-sm text-[#374151] dark:text-gray-300">
//                         {getSmsTemplatePreview()}
//                       </div>

//                       {smsTemplateVariables.length > 0 && (
//                         <div className="mb-4">
//                           <h4 className="text-sm font-semibold text-[#374151] mb-2 dark:text-gray-200">Variables:</h4>
//                           <div className="space-y-3">
//                             {smsTemplateVariables.map((variable, index) => (
//                               <div key={index}>
//                                 <label className="block text-xs font-medium text-[#6B7280] dark:text-gray-400 mb-1">{variable}</label>
//                                 <input
//                                   type="text"
//                                   value={smsVariableValues[variable] || ""}
//                                   onChange={(e) => handleSmsVariableChange(variable, e.target.value)}
//                                   className="w-full p-2 border border-[#E5E7EB] rounded-md focus:outline-none focus:ring-2 focus:ring-[#E9D5FF] focus:border-[#673AB7] dark:bg-gray-800 dark:border-gray-600 dark:text-white text-sm"
//                                   placeholder={`Enter value for ${variable}`}
//                                 />
//                               </div>
//                             ))}
//                           </div>
//                         </div>
//                       )}
//                     </div>
//                   )}
//                 </div>
//               ) : (
//                 <p className="mb-4 text-sm text-[#6B7280] dark:text-gray-400">
//                   No SMS templates found.{" "}
//                   <a
//                     href="/smsTemplates"
//                     className="text-[#673AB7] hover:text-[#5E35A6] hover:underline ml-1 font-semibold dark:text-[#E9D5FF]"
//                     rel="noopener noreferrer"
//                   >
//                     Create templates here
//                   </a>
//                 </p>
//               )}

//               {formData.mobileNo.map((number, index) => (
//                 <div key={index} className="mb-3">
//                   <label className="block text-xs font-medium text-[#6B7280] mb-1.5 dark:text-gray-400">
//                     Mobile Number {index > 0 ? index + 1 : ''}
//                   </label>
//                   <div className="flex gap-2">
//                     <PhoneInput
//                       international
//                       defaultCountry="IN"
//                       value={number}
//                       onChange={(value) => handlePhoneChange(index, value)}
//                       className="w-full dark:bg-transparent"
//                       inputClassName={`w-full p-2.5 border rounded-md focus:outline-none focus:ring-2 focus:ring-[#E9D5FF] focus:border-[#673AB7] bg-white dark:bg-gray-800 dark:text-white transition ${
//                         phoneErrors[index] ? 'border-[#EF4444]' : 'border-[#E5E7EB] dark:border-gray-600'
//                       }`}
//                       countrySelectProps={{
//                         className: "p-2 border border-[#E5E7EB] rounded-md bg-white dark:bg-gray-800 dark:border-gray-600 dark:text-white focus:outline-none focus:ring-2 focus:ring-[#E9D5FF] focus:border-[#673AB7] transition"
//                       }}
//                     />
//                     {index > 0 && (
//                       <button
//                         type="button"
//                         onClick={() => removeMobileField(index)}
//                         className="text-[#EF4444] hover:text-[#B91C1C] font-semibold text-sm px-2 self-center"
//                       >
//                         Remove
//                       </button>
//                     )}
//                   </div>
//                   {phoneErrors[index] && (
//                     <p className="text-[#EF4444] text-xs mt-1 font-medium">
//                       {phoneErrors[index]}
//                     </p>
//                   )}
//                 </div>
//               ))}

//               <button
//                 type="button"
//                 onClick={addMobileField}
//                 className="text-[#673AB7] hover:text-[#5E35A6] font-semibold text-sm transition dark:text-[#E9D5FF]"
//               >
//                 + Add another number
//               </button>
//             </div>
//           )}
//         </div>

//         {/* Status */}
//         <div>
//           <label className="block text-sm font-semibold text-[#374151] mb-2 dark:text-gray-200">Status</label>
//           <div className="flex flex-wrap gap-4">
//             {["Pending", "Completed"].map((type) => (
//               <label key={type} className="flex items-center gap-2 cursor-pointer">
//                 <input
//                   type="radio"
//                   name="status"
//                   value={type}
//                   checked={formData.status === type}
//                   onChange={handleChange}
//                   className="accent-[#673AB7] w-4 h-4"
//                 />
//                 <span
//                   className={`text-sm ${
//                     formData.status === type 
//                       ? "font-bold text-[#673AB7] dark:text-[#E9D5FF]" 
//                       : "text-[#374151] dark:text-gray-300 font-medium"
//                   }`}
//                 >
//                   {type.replace("_", " ")}
//                 </span>
//               </label>
//             ))}
//           </div>
//         </div>

//         {/* Submit */}
//         <div className="flex justify-end pt-2">
//           <button
//             type="submit"
//             className="px-5 py-2.5 w-full sm:w-auto bg-[#673AB7] hover:bg-[#5E35A6] text-white font-semibold rounded-md shadow-md transition-colors"
//           >
//             {initialData ? "Update Reminder" : "Create Reminder"}
//           </button>
//         </div>
//       </form>
//     </>
//   );
// }



import React, { useContext, useState, useEffect, useCallback } from "react";
import { API_URL } from "../../Constants";
import { AuthContext } from "../context/AuthContext";
import { Select } from "antd";
import axios from "axios";
import PhoneInput from 'react-phone-number-input';
import 'react-phone-number-input/style.css';

export default function ReminderForm({
  leadId,
  initialData = null,
  onSubmit,
  onClose,
  setOpenForm = null
}) {
  const { user } = useContext(AuthContext);
  const [users, setUsers] = useState([]);
  const [customFrequency, setCustomFrequency] = useState("");
  const [emailTemplates, setEmailTemplates] = useState([]);
  const [smsTemplates, setSmsTemplates] = useState([]);
  const [selectedEmailTemplate, setSelectedEmailTemplate] = useState(null);
  const [selectedSmsTemplate, setSelectedSmsTemplate] = useState(null);
  const [emailTemplateVariables, setEmailTemplateVariables] = useState([]);
  const [smsTemplateVariables, setSmsTemplateVariables] = useState([]);
  const [emailVariableValues, setEmailVariableValues] = useState({});
  const [smsVariableValues, setSmsVariableValues] = useState({});
  const [phoneErrors, setPhoneErrors] = useState({}); // Track phone number validation errors

  const [formData, setFormData] = useState({
    leadId: "",
    companyId: user?.accountType === "COMPANY" ? user.id : user?.companyId,
    createdById: user?.id,
    createdByName: user?.name,
    assignedTo: [],
    reminderType: "MONTHLY",
    message: "",
    date: "",
    time: "",
    status: "Pending",
    emailAutomated: false,
    email: [""],
    emailTemplateId: null,
    emailVariables: [],
    messageAutomated: false,
    mobileNo: [""],
    smsMessageId: null,
    variables: [],
  });

  // Validation functions
  const validateEmail = (email) => {
    const re = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    return re.test(String(email).toLowerCase());
  };

  const validatePhoneNumber = (phoneNumber) => {
    if (!phoneNumber) return false;
    
    // Remove all non-digit characters
    const digitsOnly = phoneNumber.replace(/\D/g, '');
    
    // Check if the number has country code + 10 digits (total 12 digits for IN)
    // Or if it's a local number with exactly 10 digits
    return digitsOnly.length === 10 || (digitsOnly.length === 12 && digitsOnly.startsWith('91'));
  };

  const getPhoneNumberDigits = (phoneNumber) => {
    if (!phoneNumber) return '';
    return phoneNumber.replace(/\D/g, '');
  };

  const handlePhoneChange = (index, value) => {
    const digits = getPhoneNumberDigits(value);
    let error = '';
    
    if (value && digits.length > 0) {
      if (digits.length > 10 && !digits.startsWith('91')) {
        error = 'Country code must be +91 for Indian numbers';
      } else if (digits.length > 12) {
        error = 'Phone number too long';
      } else if (digits.length < 10) {
        error = 'Phone number too short';
      } else if (!validatePhoneNumber(value)) {
        error = 'Please enter a valid 10-digit phone number';
      }
    }
    
    // Update errors state
    setPhoneErrors(prev => ({
      ...prev,
      [index]: error
    }));
    
    // Update form data
    const updated = [...formData.mobileNo];
    updated[index] = value;
    setFormData(prev => ({ ...prev, mobileNo: updated }));
  };

  useEffect(() => {
    setFormData((prev) => ({ ...prev, leadId }));
  }, [leadId]);

  useEffect(() => {
    if (initialData) {
      const formattedAssignedTo = (initialData.assignedTo || []).map((u) => ({
        id: u.id || u._id,
        name: u.name || `${u.fname} ${u.lname}`,
      }));

      const formattedVariables = initialData.variables 
        ? Array.isArray(initialData.variables) 
          ? initialData.variables 
          : Object.values(initialData.variables)
        : [];

      const formattedEmailVariables = initialData.emailVariables 
        ? Array.isArray(initialData.emailVariables) 
          ? initialData.emailVariables 
          : Object.values(initialData.emailVariables)
        : [];

      setFormData({
        ...formData,
        assignedTo: formattedAssignedTo || [],
        reminderType: initialData.reminderType || "MONTHLY",
        message: initialData.message || "",
        date: initialData.date || "",
        time: initialData.time || "",
        status: initialData.status || "Pending",
        emailAutomated: initialData.emailAutomated || false,
        email: initialData.email || [""],
        emailTemplateId: initialData.emailTemplateId || null,
        emailVariables: formattedEmailVariables,
        messageAutomated: initialData.messageAutomated || false,
        mobileNo: initialData.mobileNo || [""],
        smsMessageId: initialData.smsMessageId || null,
        variables: formattedVariables,
      });

      // Set selected templates from initialData
      setSelectedEmailTemplate(initialData.emailTemplateId || null);
      setSelectedSmsTemplate(initialData.smsMessageId || null);

      // Initialize variable values if they exist
      if (initialData.emailTemplateId) {
        const selectedTemplate = emailTemplates.find(
          t => t.emailTemplateId === initialData.emailTemplateId
        );
        if (selectedTemplate) {
          const vars = extractVariables(selectedTemplate.body);
          setEmailTemplateVariables(vars);
          
          const initialValues = {};
          vars.forEach((v, i) => {
            initialValues[v] = formattedEmailVariables[i] || "";
          });
          setEmailVariableValues(initialValues);
        }
      }

      if (initialData.smsMessageId) {
        const selectedTemplate = smsTemplates.find(
          t => t.mesaageId === initialData.smsMessageId
        );
        if (selectedTemplate) {
          const vars = extractVariables(selectedTemplate.templateText);
          setSmsTemplateVariables(vars);
          
          const initialValues = {};
          vars.forEach((v, i) => {
            initialValues[v] = formattedVariables[i] || "";
          });
          setSmsVariableValues(initialValues);
        }
      }
    }
  }, [initialData, emailTemplates, smsTemplates]);

  const fetchEmailTemplates = useCallback(async () => {
    try {
      const companyId = user?.accountType === "COMPANY" ? user?.id : user?.companyId;
      const response = await axios.get(
        `${API_URL}/api/emailTemplates/company/${companyId}`,
        {
          headers: {
            Authorization: `Bearer ${localStorage.getItem("token")}`,
          },
        }
      );
      setEmailTemplates(response.data.emailTemplates || []);
    } catch (error) {
      console.error("Error fetching email templates:", error);
    }
  }, [user]);

  const fetchSmsTemplates = useCallback(async () => {
    try {
      const companyId = user?.accountType === "COMPANY" ? user?.id : user?.companyId;
      const response = await axios.get(
        `${API_URL}/api/smsTemplates/company/${companyId}`,
        {
          headers: {
            Authorization: `Bearer ${localStorage.getItem("token")}`,
          },
        }
      );
      setSmsTemplates(response.data.smsTemplates || []);
    } catch (error) {
      console.error("Error fetching SMS templates:", error);
    }
  }, [user]);

  useEffect(() => {
    if (user?.id) {
      fetchEmailTemplates();
    }
  }, [user, fetchEmailTemplates]);

  useEffect(() => {
    if (user?.id) {
      fetchSmsTemplates();
    }
  }, [user, fetchSmsTemplates]);

  const extractVariables = (body) => {
    if (!body) return [];
    const regex = /\{\{(.*?)\}\}/g;
    const matches = body.match(regex);
    if (!matches) return [];
    
    return [...new Set(matches)];
  };

  const handleEmailTemplateSelect = (templateId) => {
    setSelectedEmailTemplate(templateId);
    const selected = emailTemplates.find(t => t.emailTemplateId === templateId);
    if (selected) {
      const vars = extractVariables(selected.body);
      setEmailTemplateVariables(vars);
      
      const initialValues = {};
      vars.forEach(v => {
        initialValues[v] = emailVariableValues[v] || "";
      });
      setEmailVariableValues(initialValues);
      
      setFormData(prev => ({
        ...prev,
        emailTemplateId: templateId,
        emailVariables: vars.map(v => initialValues[v] || "")
      }));
    }
  };

  const handleSmsTemplateSelect = (templateId) => {
    setSelectedSmsTemplate(templateId);
    const selected = smsTemplates.find(t => t.mesaageId === templateId);
    if (selected) {
      const vars = extractVariables(selected.templateText);
      setSmsTemplateVariables(vars);
      
      const initialValues = {};
      vars.forEach(v => {
        initialValues[v] = smsVariableValues[v] || "";
      });
      setSmsVariableValues(initialValues);
      
      setFormData(prev => ({
        ...prev,
        smsMessageId: templateId,
        variables: vars.map(v => initialValues[v] || ""
      )}));
    }
  };

  const replaceVariables = (template, values) => {
    let result = template;
    Object.entries(values).forEach(([variable, value]) => {
      result = result.replace(new RegExp(variable, 'g'), value);
    });
    return result;
  };

  const handleEmailVariableChange = (variable, value) => {
    const updatedValues = {
      ...emailVariableValues,
      [variable]: value
    };
    setEmailVariableValues(updatedValues);
    
    setFormData(prev => {
      const variableIndex = emailTemplateVariables.indexOf(variable);
      const newVariables = [...prev.emailVariables];
      if (variableIndex >= 0) {
        newVariables[variableIndex] = value;
      }
      return {
        ...prev,
        emailVariables: newVariables
      };
    });
  };

  const handleSmsVariableChange = (variable, value) => {
    const updatedValues = {
      ...smsVariableValues,
      [variable]: value
    };
    setSmsVariableValues(updatedValues);
    
    setFormData(prev => {
      const variableIndex = smsTemplateVariables.indexOf(variable);
      const newVariables = [...prev.variables];
      if (variableIndex >= 0) {
        newVariables[variableIndex] = value;
      }
      return {
        ...prev,
        variables: newVariables
      };
    });
  };

  const getEmailTemplatePreview = () => {
    const selected = emailTemplates.find(t => t.emailTemplateId === selectedEmailTemplate);
    if (!selected) return "";
    
    return replaceVariables(selected.body, emailVariableValues);
  };

  const getSmsTemplatePreview = () => {
    const selected = smsTemplates.find(t => t.mesaageId === selectedSmsTemplate);
    if (!selected) return "";
    
    return replaceVariables(selected.templateText, smsVariableValues);
  };

  useEffect(() => {
    async function fetchUsers() {
      if (!user?.id || !user?.accountType) return;
      const url =
        user.accountType === "COMPANY"
          ? `${API_URL}/api/companyuser/getByUserId?userId=${user.id}&accountType=${user.accountType}`
          : `${API_URL}/api/companyuser/getSameAndSubordinateUsers?userId=${user.id}&accountType=${user.accountType}`;

      try {
        const response = await fetch(url, {
          method: "GET",
          headers: {
            authorization: `Bearer ${localStorage.getItem("token")}`,
            "Content-Type": "application/json",
          },
        });

        if (!response.ok) {
          throw new Error(`HTTP error! Status: ${response.status}`);
        }

        const data = await response.json();
        setUsers(data);
      } catch (error) {
        console.error("Error fetching users:", error);
      }
    }

    fetchUsers();
  }, [user]);

  const handleChange = (e) => {
    const { name, value, type, checked } = e.target;
    setFormData((prev) => ({
      ...prev,
      [name]: type === "checkbox" ? checked : value,
    }));
  };

  const handleEmailChange = (index, value) => {
    const updated = [...formData.email];
    updated[index] = value;
    setFormData((prev) => ({ ...prev, email: updated }));
  };

  const addEmailField = () =>
    setFormData((prev) => ({ ...prev, email: [...prev.email, ""] }));
  const removeEmailField = (index) =>
    setFormData((prev) => ({
      ...prev,
      email: prev.email.filter((_, i) => i !== index),
    }));

  const addMobileField = () => {
    setFormData((prev) => ({
      ...prev,
      mobileNo: [...prev.mobileNo, ""],
    }));
    // Initialize error state for new field
    setPhoneErrors(prev => ({
      ...prev,
      [formData.mobileNo.length]: ''
    }));
  };

  const removeMobileField = (index) => {
    setFormData((prev) => ({
      ...prev,
      mobileNo: prev.mobileNo.filter((_, i) => i !== index),
    }));
    // Remove error state for removed field
    const newErrors = {...phoneErrors};
    delete newErrors[index];
    setPhoneErrors(newErrors);
  };

  const handleSubmit = (e) => {
    e.preventDefault();

    // Validate emails if email automation is enabled
    if (formData.emailAutomated) {
      for (const email of formData.email) {
        if (!validateEmail(email)) {
          alert(`Invalid email address: ${email}`);
          return;
        }
      }
    }

    // Validate phone numbers if message automation is enabled
    if (formData.messageAutomated) {
      let hasPhoneErrors = false;
      const newPhoneErrors = {};
      
      formData.mobileNo.forEach((phone, index) => {
        if (!validatePhoneNumber(phone)) {
          newPhoneErrors[index] = 'Please enter a valid 10-digit phone number';
          hasPhoneErrors = true;
        } else {
          newPhoneErrors[index] = '';
        }
      });
      
      setPhoneErrors(newPhoneErrors);
      
      if (hasPhoneErrors) {
        alert('Please correct the phone number errors before submitting');
        return;
      }
    }

    let frequency = 1; // default

    switch (formData.reminderType) {
      case "DAILY":
        frequency = 1;
        break;
      case "MONTHLY":
        frequency = 30;
        break;
      case "YEARLY":
        frequency = 360;
        break;
      case "CUSTOM":
        frequency = parseInt(customFrequency, 10);
        break;
      default:
        frequency = 1;
    }

    const updatedFormData = {
      ...formData,
      frequency,
      emailTemplateId: formData.emailAutomated ? selectedEmailTemplate : null,
      smsMessageId: formData.messageAutomated ? selectedSmsTemplate : null,
      emailVariables: formData.emailAutomated ? formData.emailVariables : [],
      variables: formData.messageAutomated ? formData.variables : []
    };

    if (onSubmit) {
      onSubmit(updatedFormData);
    } else {
      createReminder(updatedFormData);
    }

    if (setOpenForm) {
      setOpenForm(null);
    }
  };

  const createReminder = async (data) => {
    try {
      const response = await axios.post(`${API_URL}/api/reminders`, data, {
        headers: {
          Authorization: `Bearer ${localStorage.getItem("token")}`,
        },
      });

      if (response.data?.status === "Successful") {
        // Dispatch event to refresh reminders table
        window.dispatchEvent(new Event('reminderCreated'));
      }
    } catch (error) {
      console.error("Error creating reminder:", error);
    }
  };

  return (
    <>
      <style>{`
        @import url('https://fonts.googleapis.com/css2?family=Sora:wght@600;700&family=Inter:wght@400;500;600&display=swap');
        .cfg-heading { font-family: 'Sora', sans-serif; color: #1F2937; }
        .cfg-font { font-family: 'Inter', sans-serif; }
        
        /* Custom AntD Select Styles to match Theme */
        .custom-antd-select .ant-select-selector {
          border-color: #E5E7EB !important;
          border-radius: 0.375rem !important;
          min-height: 42px !important;
          align-items: center;
        }
        .custom-antd-select.ant-select-focused .ant-select-selector {
          border-color: #673AB7 !important;
          box-shadow: 0 0 0 2px #E9D5FF !important;
        }
        .dark .custom-antd-select .ant-select-selector {
          background-color: #374151 !important;
          border-color: #4B5563 !important;
          color: white !important;
        }
        .dark .custom-antd-select.ant-select-focused .ant-select-selector {
          box-shadow: 0 0 0 2px #8B5CF6 !important;
        }
      `}</style>

      <form onSubmit={handleSubmit} className="p-5 w-full mx-auto bg-white rounded-xl cfg-font border border-[#E5E7EB] dark:border-gray-700 dark:bg-gray-800 space-y-5 shadow-sm">
        
        {/* Reminder Type */}
        <div>
          <label className="block text-sm font-semibold text-[#374151] mb-2 dark:text-gray-200">Reminder Type</label>
          <div className="flex flex-wrap gap-4">
            {["DAILY", "MONTHLY", "YEARLY", "CUSTOM"].map((type) => (
              <label key={type} className="flex items-center gap-2 cursor-pointer">
                <input
                  type="radio"
                  name="reminderType"
                  value={type}
                  checked={formData.reminderType === type}
                  onChange={handleChange}
                  className="accent-[#673AB7] w-4 h-4"
                />
                <span
                  className={`text-sm ${
                    formData.reminderType === type
                      ? "font-bold text-[#673AB7] dark:text-[#E9D5FF]"
                      : "text-[#374151] dark:text-gray-300 font-medium"
                  }`}
                >
                  {type.replace("_", " ")}
                </span>
              </label>
            ))}
          </div>
          {formData.reminderType === "CUSTOM" && (
            <div className="mt-3">
              <label className="block text-sm font-semibold text-[#374151] mb-1.5 dark:text-gray-200">Custom Frequency (in days)</label>
              <input
                type="number"
                min="1"
                value={customFrequency}
                onChange={(e) => setCustomFrequency(e.target.value)}
                className="w-full p-2.5 border border-[#E5E7EB] rounded-md focus:outline-none focus:ring-2 focus:ring-[#E9D5FF] focus:border-[#673AB7] dark:bg-gray-700 dark:border-gray-600 dark:text-white"
                placeholder="Enter number of days"
                required
              />
            </div>
          )}
        </div>

        {/* Date & Assigned To */}
        <div className="grid grid-cols-1 sm:grid-cols-2 gap-4">
          <div>
            <label className="block text-sm font-semibold text-[#374151] mb-1.5 dark:text-gray-200">Reminder Date</label>
            <input
              type="date"
              name="date"
              className="w-full p-2.5 border border-[#E5E7EB] rounded-md focus:outline-none focus:ring-2 focus:ring-[#E9D5FF] focus:border-[#673AB7] dark:bg-gray-700 dark:border-gray-600 dark:text-white"
              value={formData.date}
              onChange={(e) => {
                handleChange(e);
                // Reset time if date is changed to today
                if (e.target.value === new Date().toISOString().split('T')[0]) {
                  const now = new Date();
                  const currentHour = now.getHours().toString().padStart(2, '0');
                  const currentMinute = now.getMinutes().toString().padStart(2, '0');
                  const currentTime = `${currentHour}:${currentMinute}`;
                  
                  setFormData(prev => ({
                    ...prev,
                    time: currentTime
                  }));
                }
              }}
              min={new Date().toISOString().split("T")[0]}
              required
            />
          </div>
          <div>
            <label className="block text-sm font-semibold text-[#374151] mb-1.5 dark:text-gray-200">Reminder Time</label>
            <input
              type="time"
              name="time"
              className="w-full p-2.5 border border-[#E5E7EB] rounded-md focus:outline-none focus:ring-2 focus:ring-[#E9D5FF] focus:border-[#673AB7] dark:bg-gray-700 dark:border-gray-600 dark:text-white"
              value={formData.time}
              onChange={handleChange}
              min={
                formData.date === new Date().toISOString().split('T')[0] 
                  ? new Date().toTimeString().slice(0, 5) 
                  : null
              }
              required
            />
          </div>
        </div>

        <div className="w-full">
          <label className="block text-sm font-semibold text-[#374151] mb-1.5 dark:text-gray-200">
            Assign To
          </label>
          <Select
            mode="multiple"
            labelInValue
            value={formData.assignedTo.map((user) => ({
              key: user.id,
              label: user.name,
            }))}
            onChange={(values) => {
              const updated = values.map((v) => ({
                id: v.key,
                name: v.label,
              }));
              setFormData((prev) => ({ ...prev, assignedTo: updated }));
            }}
            options={users.map((user) => ({
              value: user.id,
              label: `${user.fname} ${user.lname}`,
            }))}
            className="w-full custom-antd-select"
          />
        </div>

        {/* Message */}
        <div>
          <label className="block text-sm font-semibold text-[#374151] mb-1.5 dark:text-gray-200">Message</label>
          <textarea
            name="message"
            className="w-full p-2.5 border border-[#E5E7EB] rounded-md focus:outline-none focus:ring-2 focus:ring-[#E9D5FF] focus:border-[#673AB7] min-h-[100px] dark:bg-gray-700 dark:border-gray-600 dark:text-white"
            rows="3"
            placeholder="Write your reminder message..."
            value={formData.message}
            onChange={handleChange}
          ></textarea>
        </div>

        {/* Email Automation */}
        <div className="bg-[#FAF8FF] dark:bg-gray-700 p-4 border border-[#E5E7EB] dark:border-gray-600 rounded-lg">
          <label className="flex items-center gap-2 mb-3 cursor-pointer text-[#374151] dark:text-gray-200 font-semibold text-sm">
            <input
              type="checkbox"
              name="emailAutomated"
              checked={formData.emailAutomated}
              onChange={handleChange}
              className="accent-[#673AB7] w-4 h-4 rounded"
            />
            Enable Email Automation
          </label>

          {formData.emailAutomated && (
            <div className="mt-3">
              {emailTemplates.length > 0 ? (
                <div className="mb-4">
                  <label className="block text-sm font-semibold text-[#374151] mb-1.5 dark:text-gray-200">
                    Select Email Template:
                  </label>
                  <select
                    className="w-full p-2.5 border border-[#E5E7EB] rounded-md focus:outline-none focus:ring-2 focus:ring-[#E9D5FF] focus:border-[#673AB7] dark:bg-gray-800 dark:border-gray-600 dark:text-white"
                    value={selectedEmailTemplate || ""}
                    onChange={(e) => handleEmailTemplateSelect(e.target.value)}
                  >
                    <option value="">-- Select Template --</option>
                    {emailTemplates.map((template) => (
                      <option
                        key={template.emailTemplateId}
                        value={template.emailTemplateId}
                      >
                        {template.subject}
                      </option>
                    ))}
                  </select>

                  {selectedEmailTemplate && (
                    <div className="mt-4">
                      <h4 className="text-sm font-semibold text-[#374151] mb-2 dark:text-gray-200">Email Template Preview:</h4>
                      <div className="p-4 border border-[#E5E7EB] rounded-md bg-white dark:bg-gray-800 dark:border-gray-600 mb-4 whitespace-pre-wrap text-sm text-[#374151] dark:text-gray-300">
                        {getEmailTemplatePreview()}
                      </div>

                      {emailTemplateVariables.length > 0 && (
                        <div className="mb-4">
                          <h4 className="text-sm font-semibold text-[#374151] mb-2 dark:text-gray-200">Email Variables:</h4>
                          <div className="space-y-3">
                            {emailTemplateVariables.map((variable, index) => (
                              <div key={index}>
                                <label className="block text-xs font-medium text-[#6B7280] dark:text-gray-400 mb-1">{variable}</label>
                                <input
                                  type="text"
                                  value={emailVariableValues[variable] || ""}
                                  onChange={(e) => handleEmailVariableChange(variable, e.target.value)}
                                  className="w-full p-2 border border-[#E5E7EB] rounded-md focus:outline-none focus:ring-2 focus:ring-[#E9D5FF] focus:border-[#673AB7] dark:bg-gray-800 dark:border-gray-600 dark:text-white text-sm"
                                  placeholder={`Enter value for ${variable}`}
                                />
                              </div>
                            ))}
                          </div>
                        </div>
                      )}
                    </div>
                  )}
                </div>
              ) : (
                <p className="mb-4 text-sm text-[#6B7280] dark:text-gray-400">
                  No email templates found.{" "}
                  <a
                    href="/emailTemplates"
                    className="text-[#673AB7] hover:text-[#5E35A6] hover:underline ml-1 font-semibold dark:text-[#E9D5FF]"
                    rel="noopener noreferrer"
                  >
                    Create templates here
                  </a>
                </p>
              )}

              {formData.email.map((email, index) => (
                <div key={index} className="flex gap-2 mb-3">
                  <div className="flex-grow">
                    <input
                      type="email"
                      value={email}
                      onChange={(e) => handleEmailChange(index, e.target.value)}
                      className={`w-full p-2.5 border rounded-md focus:outline-none focus:ring-2 focus:ring-[#E9D5FF] focus:border-[#673AB7] dark:bg-gray-800 dark:text-white ${
                        email && !validateEmail(email) ? 'border-[#EF4444]' : 'border-[#E5E7EB] dark:border-gray-600'
                      }`}
                      placeholder="Enter email address"
                    />
                    {email && !validateEmail(email) && (
                      <p className="text-[#EF4444] text-xs mt-1 font-medium">Invalid email format</p>
                    )}
                  </div>
                  {index > 0 && (
                    <button
                      type="button"
                      onClick={() => removeEmailField(index)}
                      className="text-[#EF4444] hover:text-[#B91C1C] font-semibold text-sm px-2"
                    >
                      Remove
                    </button>
                  )}
                </div>
              ))}

              <button
                type="button"
                onClick={addEmailField}
                className="text-[#673AB7] hover:text-[#5E35A6] font-semibold text-sm transition dark:text-[#E9D5FF]"
              >
                + Add another email
              </button>
            </div>
          )}
        </div>

        {/* Message Automation */}
        <div className="bg-[#FAF8FF] dark:bg-gray-700 p-4 border border-[#E5E7EB] dark:border-gray-600 rounded-lg">
          <label className="flex items-center gap-2 mb-3 cursor-pointer text-[#374151] dark:text-gray-200 font-semibold text-sm">
            <input
              type="checkbox"
              name="messageAutomated"
              checked={formData.messageAutomated}
              onChange={handleChange}
              className="accent-[#673AB7] w-4 h-4 rounded"
            />
            Enable Message Automation
          </label>

          {formData.messageAutomated && (
            <div className="mt-3">
              {smsTemplates.length > 0 ? (
                <div className="mb-4">
                  <label className="block text-sm font-semibold text-[#374151] mb-1.5 dark:text-gray-200">
                    Select SMS Template:
                  </label>
                  <select
                    className="w-full p-2.5 border border-[#E5E7EB] rounded-md focus:outline-none focus:ring-2 focus:ring-[#E9D5FF] focus:border-[#673AB7] dark:bg-gray-800 dark:border-gray-600 dark:text-white"
                    value={selectedSmsTemplate || ""}
                    onChange={(e) => handleSmsTemplateSelect(e.target.value)}
                  >
                    <option value="">-- Select Template --</option>
                    {smsTemplates.map((template) => (
                      <option
                        key={template.mesaageId}
                        value={template.mesaageId}
                      >
                        {template.templateType}
                      </option>
                    ))}
                  </select>

                  {selectedSmsTemplate && (
                    <div className="mt-4">
                      <h4 className="text-sm font-semibold text-[#374151] mb-2 dark:text-gray-200">SMS Template Preview:</h4>
                      <div className="p-4 border border-[#E5E7EB] rounded-md bg-white dark:bg-gray-800 dark:border-gray-600 mb-4 whitespace-pre-wrap text-sm text-[#374151] dark:text-gray-300">
                        {getSmsTemplatePreview()}
                      </div>

                      {smsTemplateVariables.length > 0 && (
                        <div className="mb-4">
                          <h4 className="text-sm font-semibold text-[#374151] mb-2 dark:text-gray-200">Variables:</h4>
                          <div className="space-y-3">
                            {smsTemplateVariables.map((variable, index) => (
                              <div key={index}>
                                <label className="block text-xs font-medium text-[#6B7280] dark:text-gray-400 mb-1">{variable}</label>
                                <input
                                  type="text"
                                  value={smsVariableValues[variable] || ""}
                                  onChange={(e) => handleSmsVariableChange(variable, e.target.value)}
                                  className="w-full p-2 border border-[#E5E7EB] rounded-md focus:outline-none focus:ring-2 focus:ring-[#E9D5FF] focus:border-[#673AB7] dark:bg-gray-800 dark:border-gray-600 dark:text-white text-sm"
                                  placeholder={`Enter value for ${variable}`}
                                />
                              </div>
                            ))}
                          </div>
                        </div>
                      )}
                    </div>
                  )}
                </div>
              ) : (
                <p className="mb-4 text-sm text-[#6B7280] dark:text-gray-400">
                  No SMS templates found.{" "}
                  <a
                    href="/smsTemplates"
                    className="text-[#673AB7] hover:text-[#5E35A6] hover:underline ml-1 font-semibold dark:text-[#E9D5FF]"
                    rel="noopener noreferrer"
                  >
                    Create templates here
                  </a>
                </p>
              )}

              {formData.mobileNo.map((number, index) => (
                <div key={index} className="mb-3">
                  <label className="block text-xs font-medium text-[#6B7280] mb-1.5 dark:text-gray-400">
                    Mobile Number {index > 0 ? index + 1 : ''}
                  </label>
                  <div className="flex gap-2">
                    <PhoneInput
                      international
                      defaultCountry="IN"
                      value={number}
                      onChange={(value) => handlePhoneChange(index, value)}
                      className="w-full dark:bg-transparent"
                      inputClassName={`w-full p-2.5 border rounded-md focus:outline-none focus:ring-2 focus:ring-[#E9D5FF] focus:border-[#673AB7] bg-white dark:bg-gray-800 dark:text-white transition ${
                        phoneErrors[index] ? 'border-[#EF4444]' : 'border-[#E5E7EB] dark:border-gray-600'
                      }`}
                      countrySelectProps={{
                        className: "p-2 border border-[#E5E7EB] rounded-md bg-white dark:bg-gray-800 dark:border-gray-600 dark:text-white focus:outline-none focus:ring-2 focus:ring-[#E9D5FF] focus:border-[#673AB7] transition"
                      }}
                    />
                    {index > 0 && (
                      <button
                        type="button"
                        onClick={() => removeMobileField(index)}
                        className="text-[#EF4444] hover:text-[#B91C1C] font-semibold text-sm px-2 self-center"
                      >
                        Remove
                      </button>
                    )}
                  </div>
                  {phoneErrors[index] && (
                    <p className="text-[#EF4444] text-xs mt-1 font-medium">
                      {phoneErrors[index]}
                    </p>
                  )}
                </div>
              ))}

              <button
                type="button"
                onClick={addMobileField}
                className="text-[#673AB7] hover:text-[#5E35A6] font-semibold text-sm transition dark:text-[#E9D5FF]"
              >
                + Add another number
              </button>
            </div>
          )}
        </div>

        {/* Status */}
        <div>
          <label className="block text-sm font-semibold text-[#374151] mb-2 dark:text-gray-200">Status</label>
          <div className="flex flex-wrap gap-4">
            {["Pending", "Completed"].map((type) => (
              <label key={type} className="flex items-center gap-2 cursor-pointer">
                <input
                  type="radio"
                  name="status"
                  value={type}
                  checked={formData.status === type}
                  onChange={handleChange}
                  className="accent-[#673AB7] w-4 h-4"
                />
                <span
                  className={`text-sm ${
                    formData.status === type 
                      ? "font-bold text-[#673AB7] dark:text-[#E9D5FF]" 
                      : "text-[#374151] dark:text-gray-300 font-medium"
                  }`}
                >
                  {type.replace("_", " ")}
                </span>
              </label>
            ))}
          </div>
        </div>

        {/* Submit */}
        <div className="flex justify-end pt-2">
          <button
            type="submit"
            className="px-5 py-2.5 w-full sm:w-auto bg-[#673AB7] hover:bg-[#5E35A6] text-white font-semibold rounded-md shadow-md transition-colors"
          >
            {initialData ? "Update Reminder" : "Create Reminder"}
          </button>
        </div>
      </form>
    </>
  );
}